import { Component, Input, OnInit } from '@angular/core';
import { _datiDetail } from '../../detail/detail.component';
import { ComponentService } from '../../../services/component.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { messagefromComponent } from '../../../class/appinterface';

@Component({
  selector: 'app-crm-assegna-procedure',
  templateUrl: './crm-assegna-procedure.component.html',
  styleUrls: ['./crm-assegna-procedure.component.css']
})
export class CrmAssegnaProcedureComponent implements OnInit {

  @Input() modeEdit: 'popup' | 'batch' | 'nicaform' | 'customComponent' | 'row' | 'nicaforminternal' = 'popup';
  @Input() titolo: string;
  @Input() masterKey: string;
  @Input() modifica: boolean = true;
  @Input() aggiungi: boolean = true;
  @Input() elimina: boolean = true;
  @Input() gridHeight: number;
  @Input() gridWidth: number;
  @Input() classeGriglia: string;
  @Input() wingap: boolean;
  @Input() remoteOperations: boolean;
  @Input() paginate: boolean;
  @Input() dxoscrolling: string;
  @Input() dxosorting: string;
  @Input() service: string;
  @Input() api: string;
  @Input() soloRicercaGlobale: boolean = true
  @Input() styleContainer: string;
  @Input() classeContainer: string;
  @Input() masterDetail: _datiDetail[] = [];
  @Input() isExportDocxAvailable: boolean = false
  @Input() isExportExcelAvailable: boolean = false
  @Input() isExportPDFAvailable: boolean = false
  @Input() isStatic: boolean
  @Input() myDsStatic: any
  @Input() isDataStatic: boolean
  @Input() masterDati: any
  @Input() customAddRowButton: any
  @Input() allowColumnResizing: boolean = false;
  @Input() ricerca: boolean = true;
  @Input() costantValues: any;
  @Input() queryString: string;
  @Input() filter: string = ''
  @Input() TextAddRowButton: string = undefined
  @Input() dxocolumnchooser: boolean = true
  @Input() dataReleted
  dataSelected
  private $distruggi: Subject<void> = new Subject<void>()

  constructor(private componentService: ComponentService) { }
  ngOnDestroy(): void {
    this.$distruggi.next()
    this.$distruggi.complete()
    this.$distruggi.unsubscribe()
  }
  ngOnInit() {
    //console.log(this.costantValues)
    this.componentService.castMessage.pipe(takeUntil(this.$distruggi)).subscribe((messaggio: messagefromComponent) => {
      return this.processaMessaggio(messaggio)
    })
  }

  processaMessaggio(messaggio: messagefromComponent) {
    return
  }
  onAllEvent(event) {
    //console.log(event)
    if (event.name === "beforSave") {
      if (event.formData.quantita == 0) event.formData.quantita = 1
    }
    if (event.name === "submittedInsertOk") {
      const messaggio: messagefromComponent = {
        codeMessage: 1,
        descrMessage: '',
        traceMessage: 'reload',
        detailsMessage: '',
        destComponent: 'CrmDettagliProcedureContattiComponent'

      }
      this.componentService.emitMessage(messaggio)
    }
    if (event.name === "masterDetailInitilized") {
      //console.log(event.masterComponent.data)
      this.dataSelected = event.masterComponent.data
    }
    if (event.name === "masterDetailContentReady") {
      this.masterDetail[0]['aggiungi'] = this.dataSelected.accettaModuli == 1
      this.masterDetail[0]['costantValues'].push({ key: 'id_master_procedura', value: this.dataSelected.id })
      this.masterDetail[0]['costantValues'].push({ key: 'CodProcedura', value: this.dataSelected.CodProcedura })
      this.masterDetail[0]['costantValues'].push({ key: 'CodSede', value: this.dataSelected.CodSede })
      this.masterDetail[0]['costantValues'].push({ key: 'CodContatto', value: this.dataReleted.Cod })
      this.masterDetail[0]['costantValues'].push({ key: 'procedura_attiva', value: 1 })
    }
  }
}
